import { Typography, theme } from 'antd';

const { Title } = Typography;

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  trailing?: React.ReactNode;
  className?: string;
}

export function SectionHeader({ title, subtitle, trailing, className }: SectionHeaderProps) {
  const { token } = theme.useToken();
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 16,
        minWidth: 0,
      }}
    >
      <div className="section-header__content" style={{ minWidth: 0 }}>
        <Title
          level={5}
          style={{
            margin: 0,
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.3,
            letterSpacing: '-0.005em',
          }}
        >
          {title}
        </Title>
        {subtitle && (
          <div
            style={{
              fontSize: 12,
              marginTop: 3,
              color: token.colorTextTertiary,
              lineHeight: 1.4,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {trailing && (
        <div className="section-header__trailing" style={{ flexShrink: 0 }}>
          {trailing}
        </div>
      )}
    </div>
  );
}
